import firebase from 'firebase/app';
import { Injectable } from '@angular/core';
import 'firebase/messaging';

@Injectable({ providedIn: 'root' })
export class FirebaseService {

  private messaging;

  private firebaseConfig = {
    apiKey: "AIzaSyDmlYQhplMnbUvjVhUF6wwIorHgBQU1Z0M",
    authDomain: "urban-63c92.firebaseapp.com",
    projectId: "urban-63c92",
    messagingSenderId: "471726270943",
    appId: "1:471726270943:web:13b4e11ea10c13f0aabc6a"
  };

  constructor() {
    firebase.initializeApp(this.firebaseConfig);
  }

  async requestBrowserToken() {

    try {

      // Initialize messaging only here (not in constructor)
      if (!this.messaging) {
        this.messaging = firebase.messaging();
        this.messaging.usePublicVapidKey(
          'BEvIjeVW52rYjVMeQnAxyQqleYaLSnw3tJtUsu5c1IQhAPk70TwqUAMs9lBv68EeRytD7oINQVVJ4C9It3wcOWc'
        );
      }

      const permission = await Notification.requestPermission();
      if (permission !== 'granted') {
        return null;
      }

      const swReg = await navigator.serviceWorker.register('/accounts/firebase-messaging-sw.js');

      const token = await this.messaging.getToken({
        serviceWorkerRegistration: swReg
      });

      this.messaging.onMessage((payload) => {
        console.log('Foreground message:', payload);
      });

      return token;

    } catch (err: any) {

      console.warn('Firebase messaging skipped:', err?.message || err);
      return null;

    }
  }
}